import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { SENSITIVE } from '../../constants/SensitiveScopes';
import { jsx as _jsx } from "react/jsx-runtime";
const SensitiveScopeGroupAlert = ({
  requestedScopes
}) => {
  const isRequestingSensitiveData = useMemo(() => requestedScopes.some(scope => {
    var _scope$name;
    return (_scope$name = scope['name']) === null || _scope$name === void 0 ? void 0 : _scope$name.includes(SENSITIVE);
  }), [requestedScopes]);
  if (!isRequestingSensitiveData) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-experience-shared-components.scopesAuthorization.sensitive.alert.title"
    }),
    type: "warning",
    className: "m-top-8",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-experience-shared-components.scopesAuthorization.sensitive.alert.body"
    })
  });
};
export default SensitiveScopeGroupAlert;